import { router } from '@inertiajs/react';

type UseFilterQueryParamProps = {
    filterId: 'name' | 'status' | 'lists' | 'categories';
    defaultValue: string;
};

/**
 * Hook for interacting with server-side filters e.g. /?name=Chicago
 */
export function useFilterQueryParam({ filterId, defaultValue }: UseFilterQueryParamProps) {
    const value = new URLSearchParams(window.location.search).get(filterId) ?? defaultValue;
    const isModified = value !== defaultValue;

    function onChange(value: string) {
        const params = { ...route().params, ...Object.fromEntries(new URLSearchParams(window.location.search)) };

        if (value === '' || value === null || value === undefined) {
            delete params[filterId];
        } else {
            params[filterId] = value;
        }

        router.get(route(route().current() ?? '', params), undefined, {
            preserveScroll: true,
        });
    }

    function onReset() {
        const params = { ...route().params, ...Object.fromEntries(new URLSearchParams(window.location.search)) };
        delete params[filterId];
        router.get(route(route().current() ?? '', params), undefined, {
            preserveScroll: true,
        });
    }

    return {
        value,
        isModified,
        onChange,
        onReset,
    };
}
